import { cn } from "@/lib/utils";

import { CopyButton } from "./copy-button";

interface CodeBlockProps {
  /** The literal text shown and copied. */
  value: string;
  /** Accessible label for the copy button. */
  label?: string;
  className?: string;
}

/**
 * A monospace value in a warm-gray block with a right-aligned copy button.
 * Reused for connection URLs and copy-paste setup values.
 */
export function CodeBlock({ value, label, className }: CodeBlockProps) {
  return (
    <div
      className={cn(
        "bg-warm-gray-01 border-border flex items-center gap-2 rounded-md border px-3 py-2",
        className,
      )}
    >
      <code className="text-foreground min-w-0 flex-1 font-mono text-xs break-all">{value}</code>
      <CopyButton value={value} label={label ?? "Copy"} />
    </div>
  );
}
